import classes from './Header.module.scss'
import {Box, Button, Card, Link, Typography} from '@mui/material';
import {useNavigate} from "react-router";
import {useLocation} from "react-router-dom";
import useAuth from "../../../../hooks/auth/useAuth";
import {useTranslation} from "../../../../hooks/translations/useTranslation";
import DisplayImageProfile from "../../__molecules/DisplayImageProfile/DisplayImageProfile";
import NotificationButton from "../NotificationButton/NotificationButton";

const NAV_LINKS = [
  {label: 'Home', path: '/home'},
  {label: 'Groups', path: '/groups'},
  {label: 'History', path: '/receipts'},
  {label: 'Profile', path: '/profile'},
];

const Header = () => {

  const {isAuthenticated, user} = useAuth();

  const t = useTranslation();

  const navigate = useNavigate();

  const location = useLocation();

  const currentRoute = location.pathname.substring(1);
  const path = location.pathname.toLowerCase();
  const showNotifications = isAuthenticated && !/^\/(?:create|shared|login|register|reset-password)(?:\/|$)/.test(path)
    && !/^\/groups\/create(?:\/|$)/.test(path) && !/^\/receipt\/[^/]+\/edit(?:\/|$)/.test(path);


  return (
    <Card className={classes['header']}>
      <div className={classes['header__logo']}>
        <button
          type="button"
          aria-label="PayMe home"
          onClick={() => navigate("/")}
          className={classes['header__logo-button']}
        >
          <img src={`/plan-m-dark.png`} alt="PayMe"/>
        </button>
      </div>
      {isAuthenticated && (
        <Box
          component="nav"
          aria-label="Primary"
          sx={{display: {xs: 'none', md: 'flex'}, gap: 1, ml: 2, flexGrow: 1}}
        >
          {NAV_LINKS.map((item) => (
            <Button
              key={item.path}
              onClick={() => navigate(item.path)}
              variant="text"
              aria-current={location.pathname === item.path ? 'page' : undefined}
              sx={{
                minHeight: 44,
                fontWeight: location.pathname === item.path ? 700 : 500,
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>
      )}
      <div className={classes['header__body']}>
        {!isAuthenticated ?
          <>
            {currentRoute && currentRoute === 'register' ?
              <>
                <Typography variant={'subtitle2'}
                            className={classes['header__label']}> {t(`register.button-text`)} </Typography>
                <Link href={'login'}>
                  <Typography variant={'subtitle2'} className={classes['header__label-link']}>
                    &nbsp;{(t(`register.button-label`))}</Typography>
                </Link>
              </>
              :
              <>
                <Typography variant={'subtitle2'}
                            className={classes['header__label']}> {t(`login.button-text`)} </Typography>
                <Link href={'register'}>
                  <Typography variant={'subtitle2'} className={classes['header__label-link']}>
                    &nbsp;{(t(`login.button-label`))}</Typography>
                </Link>
              </>
            }
          </>
          :
          <div className={classes['header-body__info']}>
            <DisplayImageProfile type={'user'}
                                 username={user?.username}
                                 imageFormat={user?.profileImage ? 'data:image/jpeg;base64,' : ''}
                                 image={user?.profileImage || user?.externalProfileImage}
                                 className={classes['header-body__info-image']}
                                 onClick={() => navigate("/profile")}
            ></DisplayImageProfile>
            {showNotifications && <NotificationButton/>}
          </div>
        }
      </div>
    </Card>
  );
};

export default Header;
